import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { githubAuth } from '../services/githubAuth';

const GitHubCallback: React.FC = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      setErrorMessage(errorDescription || error);
      setStatus('error');
      return;
    }

    if (!code) {
      setErrorMessage('No authorization code received from GitHub.');
      setStatus('error');
      return;
    }

    (async () => {
      try {
        const token = await githubAuth.exchangeCode(code);
        githubAuth.saveToken(token);

        const user = await githubAuth.fetchUser(token);
        githubAuth.saveUser(user);

        // Persist the sign-in server-side (Supabase). Non-blocking.
        await githubAuth.trackUser(token);

        // Redirect to home — token is now in localStorage
        navigate('/', { replace: true });
      } catch (err) {
        setErrorMessage(err instanceof Error ? err.message : 'Authentication failed');
        setStatus('error');
      }
    })();
  }, [navigate]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-700 font-medium">Completing sign-in with GitHub…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-charcoal-card border border-charcoal-border rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-900 mb-2">Sign-in failed</h2>
        <p className="text-gray-600 mb-6">{errorMessage}</p>
        <button
          onClick={() => navigate('/', { replace: true })}
          className="btn-primary px-6 py-2"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default GitHubCallback;
